import { useEffect, useState } from "react";
import api from "@/lib/api";
import { Radio, ExternalLink, Loader2 } from "lucide-react";

export default function LiveTracker() {
  const [url, setUrl] = useState("");
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api
      .get("/settings/live-tracker")
      .then(({ data }) => setUrl(data.url || ""))
      .catch(() => setUrl(""))
      .finally(() => setLoading(false));
  }, []);

  return (
    <div className="space-y-6" data-testid="live-tracker-page">
      <div className="flex items-center justify-between flex-wrap gap-3">
        <div>
          <div className="flex items-center gap-2 mb-1">
            <span className="relative flex h-2.5 w-2.5">
              <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-[color:var(--coral)] opacity-75"></span>
              <span className="relative inline-flex rounded-full h-2.5 w-2.5 bg-[color:var(--coral)]"></span>
            </span>
            <span className="text-[10px] font-black uppercase tracking-widest text-[color:var(--coral)]">En direct</span>
          </div>
          <h1 className="brand-wordmark text-4xl sm:text-5xl text-[color:var(--deep)]">Suivi live</h1>
          <p className="text-sm text-slate-500 mt-1">
            Suivez les yoles en temps réel sur la carte Georacing pendant la course.
          </p>
        </div>
        {url && (
          <a
            href={url}
            target="_blank"
            rel="noopener noreferrer"
            data-testid="live-open-new-tab"
            className="inline-flex items-center gap-2 text-sm font-bold text-[color:var(--ocean)] hover:underline"
          >
            <ExternalLink className="h-4 w-4" />
            Ouvrir en plein écran
          </a>
        )}
      </div>

      {loading ? (
        <div className="flex items-center justify-center py-20 text-slate-400">
          <Loader2 className="h-6 w-6 animate-spin" />
        </div>
      ) : !url ? (
        <div
          className="rounded-2xl border-2 border-dashed border-slate-200 bg-white p-10 text-center"
          data-testid="live-not-configured"
        >
          <Radio className="h-10 w-10 text-slate-300 mx-auto mb-3" />
          <div className="font-bold text-[color:var(--deep)] mb-1">Aucun tracker configuré pour le moment</div>
          <p className="text-sm text-slate-500">
            Un administrateur peut ajouter l'URL Georacing depuis le panneau admin pour activer le suivi en direct.
          </p>
        </div>
      ) : (
        <div
          className="relative w-full rounded-2xl overflow-hidden bg-[color:var(--deep)] shadow-lg"
          style={{ aspectRatio: "16 / 10", minHeight: "70vh" }}
          data-testid="live-iframe-wrap"
        >
          <iframe
            src={url}
            title="Suivi live des Yoles"
            className="absolute inset-0 w-full h-full border-0"
            allow="fullscreen; geolocation"
            allowFullScreen
            data-testid="live-iframe"
          />
        </div>
      )}

      <p className="text-[11px] text-slate-400 text-center">
        Suivi propulsé par Georacing • Les données affichées ne dépendent pas de Ma Petite Yole.
      </p>
    </div>
  );
}
